// extracted by mini-css-extract-plugin
export default {"nav-links":"NavLinks_nav-links__Dfqr8","active":"NavLinks_active__hbFa4"};